import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PatternFilterDirective } from './pattern-filter.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PatternFilterDirective
  ],
  exports: [
    PatternFilterDirective
  ],
  providers: []
})
export class PatternFilterModule {
}
